import { PageShell } from "../components/PageShell";
import PilotSection from "../components/PilotSection";
import { useLanguage } from "../context/LanguageContext";
import { useRefonte } from "../translations/refonte";

export default function ProgrammePilotePage() {
  const { language } = useLanguage();
  const n = useRefonte(language).nav;

  return (
    <PageShell testid="pilot-program-page">
      <div className="wrap-cayus mb-10" data-testid="pilot-program-page">
        <div className="rule-cobalt mb-5" />
        <p className="mono-cayus text-[#0047AB] mb-4">{n.pilotProgram}</p>
      </div>
      <PilotSection />
    </PageShell>
  );
}
